export default [
  {
  path: '/active-gkrank/index',
    name: 'index',
    component: () => import('@/views/active-gkrank/index'),
    meta: {
      title: new Date().getFullYear() + '院校热度排行榜'
    }
  },  
]

